/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!********************************************!*\
  !*** ./scripts/comparison-table-helper.js ***!
  \********************************************/
if (document.body.contains(document.querySelector(".rte table"))) {
  var dots = document.querySelectorAll('.rte table tr td');

  // element that will be wrapped
  var el = document.querySelector('.rte table');
  var wrapper = document.createElement('div');
  wrapper.classList.add('compare-table-wrapper');
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
  dots.forEach(function (item) {
    if (item.innerHTML.includes('dots-1')) {
      item.classList.add('dots-1');
      item.innerHTML = '';
      item.closest('.rte table').classList.add('compare-table');
    }
    if (item.innerHTML.includes('dots-2')) {
      item.classList.add('dots-2');
      item.innerHTML = '';
      item.closest('.rte table').classList.add('compare-table');
    }
    if (item.innerHTML.includes('dots-3')) {
      item.classList.add('dots-3');
      item.innerHTML = '';
      item.closest('.rte table').classList.add('compare-table');
    }
    if (item.innerHTML.includes('dots-4')) {
      item.classList.add('dots-4');
      item.innerHTML = '';
      item.closest('.rte table').classList.add('compare-table');
    }
    if (item.innerHTML.includes('dots-5')) {
      item.classList.add('dots-5');
      item.innerHTML = '';
      item.closest('.rte table').classList.add('compare-table');
    }
  });
}
/******/ })()
;